import { render, staticRenderFns } from "./pingtaiTemp.vue?vue&type=template&id=3f2d1ae0&scoped=true&"
import script from "./pingtaiTemp.vue?vue&type=script&lang=js&"
export * from "./pingtaiTemp.vue?vue&type=script&lang=js&"
import style0 from "./pingtaiTemp.vue?vue&type=style&index=0&id=3f2d1ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d1ae0",
  null
  
)

export default component.exports